<template>
  <q-btn
    :class="['customBtn', {customBtn__outlined: outlined, 'customBtn_nowrap': nowrap}]"
    :disable="loading || disabled"
    :loading="loading"
    :outline="outlined"
    :color="color"
    no-caps
  >
    <slot />
  </q-btn>
</template>

<script setup>

const props = defineProps({
  outlined: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: 'primary-light',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  nowrap: {
    type: Boolean,
    default: false,
  },
})
</script>

<style scoped lang="scss">
@use "@/assets/styles/quasar.variables.scss" as *;

.customBtn {
  width: 100%;
  height: 46px;
  font-size: 14px;
  border-radius: 8px;
  background-color: $primary-light;
  color: #fff;

  &_nowrap {
    :deep(.q-btn__content) {
      flex-wrap: nowrap !important;
    }
  }

  &__outlined {
    background-color: #fff;
    color: $primary-light;
    &::before {
      box-shadow: none;
    }
  }
  &::before {
    box-shadow: none;
  }
}
</style>
